
function twolayout() {
  const cardbuttonmobile = document.querySelector('.grid--mobile-toggle-button');
  const cardbuttonmobile_2 = document.querySelector('.grid--mobile-toggle-button-2');
  const cardbuttonmobile_3 = document.querySelector('.grid--mobile-toggle-button-3');
  const gridItems = document.querySelectorAll('.grid__item');

  gridItems.forEach(function (grid) {
    if (grid.classList.contains("grid-mobile_layout-single-under") || grid.classList.contains("grid-mobile_layout-single-all_under")) {
      grid.classList.remove("grid-mobile_layout-single-under");
      grid.classList.remove("grid-mobile_layout-single-all_under");
      grid.classList.add("grid-mobile_layout-two");
      cardbuttonmobile.classList.add("active");
      cardbuttonmobile_2.classList.remove("active");
      cardbuttonmobile_3.classList.remove("active");
    }
  });
}

function singlelayoutallunder() {
  const cardbuttonmobile = document.querySelector('.grid--mobile-toggle-button');
  const cardbuttonmobile_2 = document.querySelector('.grid--mobile-toggle-button-2');
  const cardbuttonmobile_3 = document.querySelector('.grid--mobile-toggle-button-3');
  const gridItems = document.querySelectorAll('.grid__item');

  gridItems.forEach(function (grid) {
    if (grid.classList.contains("grid-mobile_layout-single-under") || grid.classList.contains("grid-mobile_layout-two")) {
      grid.classList.remove("grid-mobile_layout-two");
      grid.classList.remove("grid-mobile_layout-single-under");
      grid.classList.add("grid-mobile_layout-single-all_under");
      cardbuttonmobile.classList.remove("active");
      cardbuttonmobile_2.classList.remove("active");
      cardbuttonmobile_3.classList.add("active");
    }
  });
}

function singlelayoutunder() {
  const cardbuttonmobile = document.querySelector('.grid--mobile-toggle-button');
  const cardbuttonmobile_2 = document.querySelector('.grid--mobile-toggle-button-2');
  const cardbuttonmobile_3 = document.querySelector('.grid--mobile-toggle-button-3');
  const gridItems = document.querySelectorAll('.grid__item');

  gridItems.forEach(function (grid) {
    if (grid.classList.contains("grid-mobile_layout-single-all_under") || grid.classList.contains("grid-mobile_layout-two")) {
      grid.classList.remove("grid-mobile_layout-two");
      grid.classList.remove("grid-mobile_layout-single-all_under");
      grid.classList.add("grid-mobile_layout-single-under");
      cardbuttonmobile.classList.remove("active");
      cardbuttonmobile_2.classList.add("active");
      cardbuttonmobile_3.classList.remove("active"); /* fixed this too: only one active! */
    }
  });
}

function bindButtonClickmobile() {

    document.querySelectorAll('.grid__item').forEach(function (grid) {
      grid.classList.remove("grid-layout-single");
    });
  
  const cardbuttonmobile = document.querySelector('.grid--mobile-toggle-button');
  const cardbuttonmobile_2 = document.querySelector('.grid--mobile-toggle-button-2');
  const cardbuttonmobile_3 = document.querySelector('.grid--mobile-toggle-button-3');
  
  cardbuttonmobile.dataset.bound = "true";
  cardbuttonmobile_2.dataset.bound = "true";
  cardbuttonmobile_3.dataset.bound = "true";
  
  cardbuttonmobile.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    twolayout();
  });
  
  cardbuttonmobile_2.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    singlelayoutunder();
  });
  
  cardbuttonmobile_3.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    singlelayoutallunder();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  bindButtonClickmobile();
});
